export const TEXT_BANNER_VARIANT = 'text' as const;
export const CHAT_BANNER_VARIANT = 'chat' as const;
export const MARKDOWN_BANNER_VARIANT = 'markdown' as const;
export const REWARDS_BANNER_VARIANT = 'rewards' as const;

export type BannerVariant =
  | typeof TEXT_BANNER_VARIANT
  | typeof CHAT_BANNER_VARIANT
  | typeof MARKDOWN_BANNER_VARIANT
  | typeof REWARDS_BANNER_VARIANT;

export const VARIANT_GRADIENT = 'gradient' as const;
export const VARIANT_SOLID = 'solid' as const;

export type BannerStyleVariant = typeof VARIANT_GRADIENT | typeof VARIANT_SOLID;

export const VALID_BANNER_VARIANTS: readonly BannerVariant[] = [
  TEXT_BANNER_VARIANT,
  CHAT_BANNER_VARIANT,
  MARKDOWN_BANNER_VARIANT,
  REWARDS_BANNER_VARIANT,
];
